<div class="footer-container">
  <!-- therms -->  
  <div class="therms">
    <div>
      <span>{{ 'FOOTER.RIGHTS.RESERVED' | translate }}</span>
      <div>
        <a href="">{{ 'FOOTER.THERMS' | translate }}</a>
        &nbsp;|&nbsp;
        <a>{{ 'FOOTER.PRIVACY' | translate }}</a>
      </div>
    </div>

    <img src="assets/images/parts/eco_friendly.gif"/>
  </div>

  
  <!-- socials -->
  <div class="logos-container">
    <a href="//www.facebook.com/keyboardpro" target="_blank"><img class="logo" src="assets/images/parts/facebook_logo.png"/></a>
    <a href="//www.twitter.com/keyboardpro" target="_blank"><img class="logo" src="assets/images/parts/tweet_logo.png"/></a>
    <a href="//www.linkedin.com/company/keyboardpro" target="_blank"><img class="logo" src="assets/images/parts/linkedin_logo.png"/></a>
    <a href="//www.youtube.com/keyboardprous" target="_blank"><img class="logo" src="assets/images/parts/youtube_logo.png"/></a>
    <a href="//www.flickr.com/keyboardpro" target="_blank"><img class="logo" src="assets/images/parts/flickr_logo.png"/></a>
    <a href="//www.pinterest.com/keyboardpro" target="_blank"><img class="logo" src="assets/images/parts/pinterest_logo.png"/></a>
  </div>

</div>